import { provide, Ref, ref } from "vue";
import { InjectionKey } from "vue";
import { useLocalStorage } from "@vueuse/core";

export type DownloadGraphProperties = {
	showTitle: boolean;
	showSnapshotDate: boolean;
	showChartConfig: boolean;
	backgroundColor: string;
	resolution: { w: number; h: number } | null;
};

export type DownloadGraphState = {
	properties: Ref<DownloadGraphProperties>;
	graphTitle: Ref<string>;
	graphImage: Ref<Blob | null>;
	startDownload: Ref<boolean>;
};

export type DownloadGraphKey = InjectionKey<DownloadGraphState>;

export function useDownloadGraph(key: DownloadGraphKey) {
	const downloadProperties = useLocalStorage<DownloadGraphProperties>(
		"downloadGraphProperties",
		{
			showTitle: true,
			showSnapshotDate: true,
			showChartConfig: true,
			backgroundColor: "white",
			resolution: null,
		}
	);

	provide(key, {
		properties: downloadProperties,
		graphTitle: ref(""),
		graphImage: ref(null),
		startDownload: ref(false),
	});

	return {
		key,
		downloadProperties,
	};
}
export const explorerGraphKey: DownloadGraphKey = Symbol("explorerGraph");
export const dashboardGraphKey: DownloadGraphKey = Symbol("dashboardGraph");
